export default __webpack_public_path__ + "static/media/logo-desktop.00ea7fc9.svg";